// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
var Location = /** @class */ (function () {
    function Location() {
    }
    return Location;
}());
export { Location };
//# sourceMappingURL=Location.js.map